export default "__VITE_ASSET__B$Z6DFrs__"